var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"totals-wrapper wrapper-1"},[_c('span',{staticClass:"totals"},[_c('span',[_vm._v(_vm._s(_vm.$t('Total Files'))+": "+_vm._s(_vm.totalFiles))]),_vm._v(" "),_c('span',[_vm._v("|")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('Size'))+": "+_vm._s(_vm.totalSize))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }